/** Mini-app product domains — never use RepuAgency subscriber UI on these hosts. */
const MINI_APP_HOST_SUFFIXES = [
  'zensocial.io',
  'tapengine.io',
  'getsocialreviews.com',
  'reviewsurge.co',
  'socialfusionai.com',
  'instastream.co',
  'leadmachine.io',
  'reviewour.biz',
  'showmyrep.io',
  'rvrply.com',
]

function normalizeHost(value) {
  if (!value || typeof value !== 'string') {
    return ''
  }
  let candidate = value.trim().toLowerCase()
  if (!candidate) {
    return ''
  }
  candidate = candidate.replace(/^https?:\/\//, '').split('/')[0]
  return candidate.replace(/^\.+|\.+$/g, '')
}

function getAgencyDomainsFromUser(user) {
  if (!user || !user.agency) {
    return []
  }

  const domains = []
  const whitelabelDomain = normalizeHost(user.agency?.whitelabel?.domain)
  if (whitelabelDomain) {
    domains.push(whitelabelDomain)
  }

  if (Array.isArray(user.agency?.domains)) {
    for (const domainRow of user.agency.domains) {
      const value = normalizeHost(domainRow?.domain)
      if (value) {
        domains.push(value)
      }
    }
  }

  return [...new Set(domains)]
}

/**
 * Hosts that may show the RepuAgency subscriber UI (new routes + chrome).
 * Allow core RepuAgency hosts plus mapped white-label domains, but block mini-app product hosts.
 */
export function isRepuagencyNewUiHost(user = null) {
  if (typeof window === 'undefined' || !window.location?.hostname) {
    return false
  }

  const host = normalizeHost(window.location.hostname)

  if (host === 'localhost' || host === '127.0.0.1') {
    return true
  }

  for (const suffix of MINI_APP_HOST_SUFFIXES) {
    if (host === suffix || host.endsWith(`.${suffix}`)) {
      return false
    }
  }

  if (host.includes('repuagency.com') || host.includes('reputationhub.io')) {
    return true
  }

  const allowedDomains = getAgencyDomainsFromUser(user)
  return allowedDomains.some((domain) => host === domain || host.endsWith(`.${domain}`))
}

function parseUsesNewUiFlag(user) {
  if (!user || user.uses_new_ui === undefined || user.uses_new_ui === null) {
    return false
  }
  const v = user.uses_new_ui
  if (v === true) return true
  if (v === false) return false
  if (typeof v === 'number') return v === 1
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase()
    return s === 'true' || s === '1'
  }
  return false
}

/**
 * Apply host policy to a user object from the API (clears uses_new_ui off RepuAgency hosts).
 * @param {Object|null|undefined} user
 * @returns {Object|null|undefined}
 */
export function applyNewUiHostPolicyToUser(user) {
  if (!user) {
    return user
  }
  if (isRepuagencyNewUiHost(user)) {
    return user
  }
  const next = { ...user, uses_new_ui: false }
  if (user.agency && typeof user.agency === 'object') {
    next.agency = { ...user.agency, uses_new_ui: false }
  }
  return next
}

/**
 * Plan eligibility from API `uses_new_ui` plus RepuAgency product host only.
 * @param {Object|null|undefined} user
 * @returns {boolean}
 */
export function userUsesNewUiEligible(user) {
  if (!isRepuagencyNewUiHost(user)) {
    return false
  }
  return parseUsesNewUiFlag(user)
}
